import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';

const LoginInfoDisplay = () => {
  const { user } = useAuth();
  const [currentCredentials, setCurrentCredentials] = useState({
    email: '',
    password: ''
  });

  useEffect(() => {
    const updateCredentials = () => {
      const adminProfile = JSON.parse(localStorage.getItem('adminProfile') || '{}');
      const currentPassword = localStorage.getItem('adminPassword') || 'baru123';
      
      setCurrentCredentials({
        email: adminProfile.email || user?.email || 'emiliawati1@sewaapartemen.com',
        password: currentPassword
      });
    };

    updateCredentials();
    
    // Listen for storage changes
    const handleStorageChange = () => {
      updateCredentials();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also update when user changes
    const interval = setInterval(updateCredentials, 1000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [user]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-4 p-4 bg-blue-50 rounded-xl border border-blue-200"
    >
      <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
        <i className="fas fa-info-circle mr-2"></i>
        Current Login Credentials
      </h4>
      
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Email:</span>
          <span className="font-medium text-blue-700">{currentCredentials.email}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Password:</span>
          <span className="font-medium text-blue-700">{currentCredentials.password}</span>
        </div>
      </div>
      
      <p className="text-xs text-blue-600 mt-2">
        <i className="fas fa-lightbulb mr-1"></i>
        Use these credentials to login after logout
      </p>
    </motion.div>
  );
};

export default LoginInfoDisplay;